define('datakit/lib/belongs.to.relationship.type',['require','exports','module','backbone','./relationship.type'],function(require, exports, module) {
  var Backbone         = require('backbone');
  var RelationshipType = require('./relationship.type');


  var BelongsToRelationshipType = RelationshipType.extend({
    supportedResourceClass: Backbone.Model,
    canFetchResource: function() {
      return !!this.foreignModel.get(this.foreignKey);
    },
    staleOnForeignModelEvent: function() {
      return 'change:' + this.foreignKey;
    },
    configureResource: function() {
      this.resource.set(this.resource.idAttribute, this.foreignModel.get(this.foreignKey));
    }
  });

  module.exports = BelongsToRelationshipType;
});
